// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/version/:version/diff" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdVersionDiff } from "./constants";
import type { GenerativeAiAgentIdVersionDiffResult } from "./types";
import { isGenerativeAiAgentIdVersionDiffResult } from "./validators";

export const getGenerativeAiAgentIdVersionDiff = reactQueryFetcherAdapter(
  generativeAiAgentIdVersionDiff,
  (
    signal: AbortSignal,
    id: string,
    version: number,
    appGroupId?: string
  ): Promise<GenerativeAiAgentIdVersionDiffResult> => {
    return fetch(
      `/generative_ai/agent/${id}/version/${version}/diff`,
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  },
  isGenerativeAiAgentIdVersionDiffResult
);
